import { createBrowserHistory } from 'history';
const historico = createBrowserHistory();

export default historico;
